export const ROOT = "/";
export const HOME = "/home";
export const LOGIN = "/login";
export const PAGE1 = "/page1";
export const SEARCH_RESULT = "/searchResult/:searchType/:searchValue";
export const REQUISITION_SEARCH = "/requisitionSearch/:searchValue";
export const PARENT_CLIENT = "/parentClient/:parentClientCode";
export const ROSTER_SEARCH = "/rosterSearch/:classRequestId/:rosterId";
export const AUTH_PAGE1 = "/authorized1";
export const NEW_ROSTER_CONFIG =
  "/new-roster-config/:type/:classRosterId/:classRequestId/:data";

export const ROSTER_CONFIG =
  "/roster-config/:type/:classRosterId/:classRequestId/:data";
export const BULK_EDIT = "/bulkEdit/:roasterId";
export const ATTENDANCE = "/bulkEdit/attendance";
export const TRAINEE_DETAILS =
  "/trainee-details/:OracleId/:FirstName/:LastName";
export const PII_REPORT = "/contact-roster/:classRosterId";
export const PII_REPORT_BY_ORACLEID = "/pii-report-oracle/:oracleId";
export const OBT_INFO_MANAGEMENT = "/obtinfo";
export const OBT_IDM_OG_OWNERSHIP = "/obtinfo/accountOwnership";
export const OBT_BULK_EDIT = "/obtinfo/bulkEditAccountOwnerShip";
export const OBT_CREATE_MILESTONES = "/obtinfo/createMilestones";
export const OBT_ASSIGN_MILESTONES = "/obtinfo/assignMilestones";
export const PII_RITM_REPORT = "/OBT/:ticketNumber";
export const PII_FACILITIES_REPORT = "/FAC/:ticketNumber";
export const ASSIGN_TRAINEES = "/home/assignTrainees";
export const CREATE_IDM_TICKET = "/createIDMTicket/";
export const LEARNPOINT_HOME = "/learnpoint";
export const LEARNPOINT_INFO = "/learnpoint/infoSection/:Type";
export const MILESTONES = "/MileStones";
export const CREATEMILESTONES = "/createMilestones";
export const WELCOME = "/welcome";
export const CENTERPOINT = "/centerpoint";
export const LEARNPOINT = "/learnpoint";
export const REQUEST_ACCESS =
  "https://teletechinc.sharepoint.com/:w:/s/GS2013_SP2007_IT/CorporateDesktopOperations/RemoteRegionalSupportModel/ERfWIx3YcKhCgKyTF6TkmnEBnqMqt-p_yIAt4oRKcBjdIA?e=sdZvnm";
export const MOSAIC =
  "https://teletechinc.sharepoint.com/sites/mosaicIntranetProdHome";
export const PROCESS_GUIDE =
  "https://teletechinc.sharepoint.com/teams/Global_Technology/SitePages/Agent-State-Tracking-Tool.aspx";
export const NEW_HOME = "/home";
export const SEARCH_REQUESTS = "/home/searchrequests";
export const SEARCH_TRAINEES = "/home/searchtrainees";
export const SEARCH_REQUISITIONS = "/home/searchrequisitions";
export const SEARCH_ROSTERS = "/home/searchrosters";
export const CLASS_ROSTER_CONFIG = "/home/rosterconfig";
export const GENERATE_IDM_TICKET = "/home/generateidmticket";
export const CREATE_CLASSREQUEST = "/home/createclassrequest";
export const SHIPPING_REPORT = "/shipping/:ticketNumber";
export const SELF_IMAGE =
  "https://teletechinc.sharepoint.com/sites/mosaicIntranetProdHome/_layouts/15/UserPhoto.aspx?Size=S&AccountName=";
export const CORERATIO = "/coreratio";
export const LOG_INSIGHTS = "/log-insights";
